import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';

export async function deletePlan(planId: string) {
  await db.deleteDoc(db.doc(firestore, 'plans', planId));
}
